import { IServerProps } from 'common/types/common';
import { Layout } from 'layout';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const HeroContact = dynamic(() =>
  import('modules/contact/HeroContact').then(mod => mod.HeroContact),
);
const ContactForm = dynamic(() =>
  import('modules/contact/ContactForm').then(mod => mod.ContactForm),
);

const ContactPage = () => {
  const { t } = useTranslation('meta');

  const seo = {
    alternate: t('contactProject.alternate', { returnObjects: true }),
    description: t('contactProject.description'),
    image: t('contactProject.image'),
    slug: t('contactProject.slug'),
    title: t('contactProject.title'),
  };
  return (
    <Layout dark seo={seo}>
      <HeroContact isProject />
      <ContactForm id="contact-project" isProject />
    </Layout>
  );
};

export const getServerSideProps = async (
  context: GetServerSidePropsContext,
): Promise<IServerProps<IContactPageProps>> => {
  const locale = await serverSideTranslations(context.locale || 'en', [
    'common',
    'meta',
    'pageContact',
  ]);

  return {
    props: {
      data: { referer: context.req.headers.referer || null },
      ...locale,
    },
  };
};

interface IContactPageProps {
  data: { referer?: string | null } | Record<string, never>;
}

export default ContactPage;
